import { GlobalSearchParams } from "./parseSearchParams"

export const updateUrlParams = (
  searchParams: URLSearchParams,
  newParam: Partial<GlobalSearchParams>,
) => {
  // console.log("Redirecting to:", newParam)

  const params = new URLSearchParams(searchParams.toString())

  Object.entries(newParam).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") {
      params.delete(key)
    } else {
      params.set(key, String(value))
    }
  })

  window.history.pushState(null, "", `?${params.toString()}`)
}
